import { render, staticRenderFns } from "./wty-table.vue?vue&type=template&id=0f610476&scoped=true&"
import script from "./wty-table.vue?vue&type=script&lang=js&"
export * from "./wty-table.vue?vue&type=script&lang=js&"
import style0 from "./wty-table.vue?vue&type=style&index=0&id=0f610476&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f610476",
  null
  
)

export default component.exports